import React from 'react'
import { graphql } from 'gatsby'
import { Image } from '../../components/image'
import { useSnippets } from '../../components/snippet'
import { LinkButton } from '../../components/button'
import { Collapse } from '../../components/collapse'
import { UnorderedList } from '../../components/list'
import {
  Container,
  Intro,
  Subtitle,
  Text,
  Title,
  Section,
  Background,
} from '../../components/page'

import * as styles from './ambassadors-roles.module.scss'

export type AmbassadorsRolesProps = Queries.AmbassadorsRolesFragment

export const AmbassadorsRoles = ({
  title,
  text,
  roles,
}: AmbassadorsRolesProps) => {
  const s = useSnippets()
  return (
    <Section className={styles.section} variant="ambassadorsroles">
      <Container>
        <Title color="light" center>
          {title}
        </Title>
        <Intro color="light" center>
          {text?.text}
        </Intro>
        <div className={styles.roles}>
          {roles?.map((role, i) => (
            <div
              key={role?.id}
              className={`${styles.role} ${i % 2 ? styles.odd : styles.even}`}
            >
              <div className={styles.text}>
                <Subtitle color="light">{role?.name}</Subtitle>
                <Text color="light">{role?.description?.description}</Text>
                <Collapse className={styles.collapse}>
                  <Collapse.Button color="primary">
                    {s.read_more_about_application_criteria}
                  </Collapse.Button>
                  <Collapse.Content color="light">
                    <UnorderedList color="light">
                      {role?.criteria?.map((criteria, index) => (
                        <li key={index}>{criteria}</li>
                      ))}
                    </UnorderedList>
                  </Collapse.Content>
                </Collapse>
                <LinkButton
                  href={role?.applyUrl!}
                  target="_blank"
                  color="primary"
                  variant="fill"
                >
                  {s.apply_now}
                </LinkButton>
              </div>
              <div className={styles.image}>
                <Image
                  image={role?.image}
                  alt={role?.image?.title!}
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
      </Container>
      <Background variant="ambassadorsroles" />
    </Section>
  )
}

export const AmbassadorsRolesFragments = graphql`
  fragment AmbassadorRoleImage on ContentfulAsset {
    __typename
    id
    title
    gatsbyImageData
  }
  fragment AmbassadorRole on ContentfulAmbassadorRole {
    __typename
    id
    name
    slug
    applyUrl
    description {
      description
    }
    criteria
    image {
      ...AmbassadorRoleImage
    }
  }
  fragment AmbassadorsRoles on ContentfulAmbassadorsRoles {
    __typename
    id
    title
    text {
      text
    }
    roles {
      ...AmbassadorRole
    }
  }
`
